export type CustomerCategory = 'hotel' | 'non_hotel';
export interface IntakeTeam { id: number; name: string; slug: string }

export function customerCategory(teams: IntakeTeam[], verticalId?: number): CustomerCategory {
  return teams.find(team => team.id === verticalId)?.slug === 'hotels' ? 'hotel' : 'non_hotel';
}

export function intakeTeams(teams: IntakeTeam[], category: CustomerCategory): IntakeTeam[] {
  return teams.filter(team => (team.slug === 'hotels') === (category === 'hotel'));
}

export function intakeTeamLabel(team: IntakeTeam): string {
  const purpose: Record<string, string> = { lighting: 'Lighting', homeowners: 'Homeowners', dealers: 'Dealers' };
  const description = purpose[team.slug];
  return description && description.toLowerCase() !== team.name.toLowerCase() ? `${team.name} — ${description}` : team.name;
}
